import { render, staticRenderFns } from "./file_field.vue?vue&type=template&id=5b52586a&lang=pug&"
import script from "./file_field.vue?vue&type=script&lang=js&"
export * from "./file_field.vue?vue&type=script&lang=js&"
import style0 from "./file_field.vue?vue&type=style&index=0&id=5b52586a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports